import CustomElementComponent_CustomElementComponent from '../components/CustomElementComponent/viewer/skinComps/CustomElement/CustomElement.skin';
import CustomElementComponent_CustomElementController from '../components/CustomElementComponent/viewer/CustomElementComponent.controller';


const CustomElementComponent_CustomElement = {
  component: CustomElementComponent_CustomElementComponent,
  controller: CustomElementComponent_CustomElementController
};


export const components = {
  ['CustomElementComponent_CustomElement']: CustomElementComponent_CustomElement
};

